import { Controller } from "@hotwired/stimulus";
// Connects to data-controller="renewal-product-complete"
export default class extends Controller {
  connect() {
    this.checkbox = document.getElementById("accept_terms");
    this.feedback = document.getElementById("accept_terms_feedback");
    this.element.addEventListener("click", (e) => this.handleClick(e));
    this.checkbox.addEventListener("change", () => this.flag(!this.checkbox.checked));
  }
  handleClick(e) {
    if (this.checkbox.checked) return;

    e.preventDefault();
    this.flag(true);
    this.checkbox.focus();
  }
  flag(invalid) {
    this.checkbox.classList.toggle("is-invalid", invalid);
    this.feedback.classList.toggle("d-block", invalid);
  }
}
